import { useTranslation } from "react-i18next";

const PAYMENT_ICONS = [
  { src: "https://upacjenta.pl/next-assets/payments-icons/payu-icon.png", alt: "PayU", width: 46, height: 22 },
  { src: "https://upacjenta.pl/next-assets/payments-icons/visa-icon.png", alt: "Visa", width: 44, height: 18 },
  {
    src: "https://upacjenta.pl/next-assets/payments-icons/mastercard-icon.png",
    alt: "Mastercard",
    width: 29,
    height: 23,
  },
  { src: "https://upacjenta.pl/next-assets/payments-icons/blik-icon.png", alt: "BLIK", width: 51, height: 32 },
];

export const PayUInfo = () => {
  const { t } = useTranslation("translation", { keyPrefix: "GROUP_ACTIONS_ORDERING.SUMMARY" });

  return (
    <div className="mt-4 flex flex-col items-center gap-y-2">
      <div className="flex items-center justify-center gap-4">
        {PAYMENT_ICONS.map(({ src, alt, width, height }) => (
          <img key={alt} src={src} alt={alt} width={width} height={height} />
        ))}
      </div>
      <p className="text-center text-gray-400 text-xs">{t("PAYMENT_INFO")}</p>
    </div>
  );
};
